import styled from 'styled-components';

export const Table = styled.table`
   width: 100%;
   border-collapse: collapse;
   border-spacing: 0;
   border: 1px solid #ddd;

   th {
      background-color: #f5f5f5;
   }

   th,
   td {
      padding: 8px;
      text-align: left;
      border: 1px solid #ddd;
   }
`;

export const Chip = styled.span<{ active: boolean }>`
   background-color: #e0e0e0;
   border-radius: 5px;
   font-weight: bold;
   font-size: 12px;
   padding: 5px;
   margin-left: 5px;
   background-color: ${(props) => props.active ? '#4caf50' : '#e0e0e0'};
   color: ${(props) => props.active ? '#fff' : '#000'};
`